import {
  BanknotesIcon,
  Cog6ToothIcon,
  HomeIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

export default function routes(pathname, userType) {
  var title;
  var routes;

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: true,
      section: "Home",
    },

    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: true,
      open: false,
      section: "Setup",
      children: [
        { name: "Users", href: "/users", current: false },
        { name: "User Businesses", href: "/user-businesses", current: false },
      ],
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),
    title: title,
  };

  return returnArray;
}
